import Grid from '@mui/material/Grid2'
import { personAPI } from 'api/PersonAPI'
import CardContentText from 'Components/reusable/CaleoCustomComponents/CardContentText'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IPerson } from 'types/userInterfaces'
import SalesContact from './SalesContact'

/** @notExported */
interface ISalesContact {
  /** Person data */
  personData: IPerson
}

/**
 * Contact sales card component.
 *
 * @returns Contact sales card component.
 * @notExported
 */
const ContactSalesCard: React.FC<ISalesContact> = ({ personData }) => {
  const [salesContacts, setSalesContacts] = useState<IPerson[]>()
  const { t } = useTranslation()

  useEffect(() => {
    const controller = new AbortController()

    ;(async () => {
      if (personData?.organizationId) {
        const results = await personAPI.getSalesContacts(personData?.organizationId, controller)
        setSalesContacts(results)
      }
    })()

    return () => {
      controller.abort()
    }
  }, [personData?.organizationId])

  return (
    <Grid sx={{ maxWidth: 1400, m: '0 auto' }}>
      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={3}>
        <Grid>
          <CardContentText type="cardSubHeader">{t('contactSales')}</CardContentText>
        </Grid>
        <Grid>
          <Grid container alignItems="center" spacing={4} justifyContent="center">
            {salesContacts?.map((salesContact, i) => <SalesContact salesContact={salesContact} key={i} />)}
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end">
        <Grid>
          <CardContentText type={'priceInfo'}>{`${t('officeAddress')}: ${personData.Site?.streetAddress}, ${
            personData.Site?.city
          }, ${personData.Site?.countryCode}`}</CardContentText>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ContactSalesCard
